<template>
    <b-modal
        id="removeTreatmentModal"
        ref="removeTreatmentModal"
        :lazy="true"
        title-tag="h2"
        title="Remove Patient"
    >
        <b-form>
            <div v-if="data.appointment_id">
                Removing this patient from the treatment board will reverse the
                patient's appointment status to be checked in. Do you want to
                proceed?
            </div>
            <div v-else>
                Do you wish to remove this patient from the treatment board?
            </div>
        </b-form>
        <div slot="modal-footer" class="w-100">
            <b-button
                @click="$refs.removeTreatmentModal.hide('cancel')"
                class="float-left"
                variant="secondary"
                >Cancel</b-button
            >
            <div class="float-right">
                <img v-if="loading" src="assets/ajax-loader.gif" />
                <b-button
                    v-if="!loading"
                    @click="remove"
                    class="float-left"
                    variant="primary"
                    >Remove</b-button
                >
            </div>
        </div>
    </b-modal>
</template>
<script>
import { assign } from "lodash";
export default {
    data() {
        return {
            data: {
                appointment_id: null
            },
            loading: false
        };
    },
    methods: {
        open(data) {
            this.data = assign(this.data, data);
            this.$refs["removeTreatmentModal"].show();
        },
        async remove() {
            let self = this;
            let params = self.data;
            let success = false;
            self.loading = true;

            try {
                await self.$http
                    .delete(
                        process.env.BARRAMUNDI +
                            "schedule/treatment-board/" +
                            self.data.id
                    )
                    .then(function (response) {
                        if (response.data.response.message.code === 200) {
                            self.$root.$emit("treatment-board-refresh", {
                                params: response.data.response,
                                isRemove: true
                            });
                            success = true;
                        }
                    });
                if (success) {
                    self.$refs["removeTreatmentModal"].hide();
                    self._message("Remove treatment successfully");
                }
            } catch (error) {
                this.loading = false;
                console.error(error);
                this._message("Error saving data", "danger");
            }
        }
    }
};
</script>
